import * as React from "react";
import {WithApi, WithApiProperties} from "../../common/util/WithApi";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {Role, User} from "../../user/model";
import {Logger} from "../../common/util/Logger";
import {Button, Checkbox, ControlLabel, FormControl, FormGroup, HelpBlock} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import {ModalMessageDialog, ModalMessageDialogMode} from "../commons/ModalMessageDialog";

interface State {
  username: string;
  password: string;
  passwordConfirm: string;
  rolesSelected: string[];
  enabled: boolean;
  roles: Role[],
  modalDialog: JSX.Element[];
}

class UserDetailsPageComponent extends React.Component<WithApiProperties & InjectedIntlProps, State> {
  _logger: Logger = Logger.getLogger("settings.roles-page");
  private originalRolesSelected: string[] = [];

  constructor(props) {
    super(props);
    this.state = {
      username: (this.props as any).match.params.username,
      password: "",
      passwordConfirm: "",
      roles: [],
      rolesSelected: [],
      enabled: true,
      modalDialog: []
    }
  }

  componentDidMount() {
      const {intl} = this.props;
      this.props.api.getAllRoles().then((roles: Role[]) => {
      const user: User = {
        username: this.state.username,
      }
      this.props.api.getUser(user).then((u) => {
            this.originalRolesSelected = u.roles ? u.roles : [];
            this.setState({
              roles,
              rolesSelected: this.originalRolesSelected,
              enabled: u.enabled,
            })
          },
          (e) => {
            this._logger.error("Error occurred while retrieving user.", e);
              this.openModal(<ModalMessageDialog
                  key="user-retrieve-error"
                  onClose={this.closeModal}
                  mode={ModalMessageDialogMode.ERROR}
                  body={intl.formatMessage({
                  id: "studio.users.user-details.user-retrieve-error",
                  defaultMessage: "Failed to connect to server retrieve user information."
                  })}
              />);
          })
    }, (e) => {
        this._logger.error("Error occurred while retrieving roles.", e);
        this.openModal(<ModalMessageDialog
            key="roles-retrieve-error"
            onClose={this.closeModal}
            mode={ModalMessageDialogMode.ERROR}
            body={intl.formatMessage({
            id: "studio.users.user-details.roles-retrieve-error",
            defaultMessage: "Failed to connect to server to retrieve roles."
            })}
        />);
    })
  }

  private handleChange = (event: any) => {
    const {name, value} = event.target;
    const realValue = event.target.type === 'checkbox' ? event.target.checked : value;
    if (name === "rolesSelected" && event.target.selectedOptions) {
      const selectedOptions = event.target.selectedOptions;
      const values = [];
      for (let i = 0, l = selectedOptions.length; i < l; i++) {
        values.push(selectedOptions[i].value);
      }
      this.setState({
        rolesSelected: values
      });
    } else {
      // @ts-ignore
      this.setState({[name]: realValue});
    }
  }

  private update = (event: any) => {
      event.preventDefault();
      event.stopPropagation();
      const {intl} = this.props;
      const user: User = {
      username: this.state.username,
      roles: this.state.rolesSelected,
      enabled: this.state.enabled
    }
    this.props.api.updateUser(user).then((_) => {
      // Declare success
          this.originalRolesSelected = this.state.rolesSelected;
            this.openModal(<ModalMessageDialog
                key="update-user-success"
                onClose={this.closeModal}
                mode={ModalMessageDialogMode.SUCCESS}
                body={intl.formatMessage({
                id: "studio.users.user-details.update-user-success",
                defaultMessage: "User updated successfully."
                })}
            />);
        },
        (e) => {
          this._logger.error("Error occurred while updating user.", e);
            this.openModal(<ModalMessageDialog
                key="update-user-error"
                onClose={this.closeModal}
                mode={ModalMessageDialogMode.ERROR}
                body={intl.formatMessage({
                id: "studio.users.user-details.update-user-error",
                defaultMessage: "Failed to update user."
                })}
            />);
        })
  }

  private updatePassword  = (event:any) => {
      event.preventDefault();
      event.stopPropagation();
      const {intl} = this.props;
    if (this.state.password.length > 3 && this.state.password === this.state.passwordConfirm) {
      const user: User = {
        username: this.state.username,
        userAuthCredentials: this.state.password,
        roles: this.originalRolesSelected
      }
      this.props.api.updateUser(user).then((_) => {
        this.setState({
              password: "",
          passwordConfirm: "",
        })
              this.openModal(<ModalMessageDialog
                  key="update-password-success"
                  onClose={this.closeModal}
                  mode={ModalMessageDialogMode.SUCCESS}
                  body={intl.formatMessage({
                  id: "studio.users.user-details.update-password-success",
                  defaultMessage: "Password updated successfully."
                  })}
              />);
          },
          (e) => {
              this.setState({
              password: "",
                  passwordConfirm: "",
              })
            this._logger.error("Error occurred while changing password.", e);
              this.openModal(<ModalMessageDialog
                  key="update-password-error"
                  onClose={this.closeModal}
                  mode={ModalMessageDialogMode.ERROR}
                  body={intl.formatMessage({
                  id: "studio.users.user-details.update-password-error",
                  defaultMessage: "Failed to update password."
                  })}
              />);
          })
    } else {
          this.setState({
        password: "",
              passwordConfirm: "",
          })
          this.openModal(<ModalMessageDialog
              key="invalid-password-error"
              onClose={this.closeModal}
              mode={ModalMessageDialogMode.ERROR}
              body={intl.formatMessage({
            id: "studio.users.user-details.invalid-password-error",
            defaultMessage: "Password does not match criteria. Try again."
              })}
          />);
    }
  }

  private closeModal = () => {
    this.setState({modalDialog: []})
    }

  private openModal = (modal: JSX.Element) => {
    this.setState({modalDialog: [modal]})
    }

  render() {
    // @ts-ignore
    const roleOptions = this.state.roles && this.state.roles.length > 0 ?
        this.state.roles.map(r => {
          return (<option value={r.role} key={r.role}>{r.role}</option>)
        }) : []
    return (
        <div>
        <form onSubmit={this.update}>
          <h1>
            <FormattedMessage id="studio.users.user-details.title"
                                defaultMessage="Modify User"/>
          </h1>
          <hr/>
          <FormGroup controlId="group-rolename-id">
            <ControlLabel>
              <FormattedMessage id="studio.users.user-details.label-username"
                                defaultMessage="User name:"
              />
            </ControlLabel>
            <FormControl autoFocus type="text" name="role" value={this.state.username} readOnly={true}/>
          </FormGroup>

          <Checkbox name="enabled" checked={this.state.enabled} onChange={this.handleChange}>
            <FormattedMessage id="studio.users.user-details.checkbox-user-enabled"
                              defaultMessage="Enabled"
            />
          </Checkbox>

            <FormGroup>
                <ControlLabel htmlFor="user-select-roles-id">
                    <FormattedMessage id="studio.users.user-details.label-roles"
                                      defaultMessage="Select roles:"
                    />
                </ControlLabel>
                <FormControl type="text" value={this.state.rolesSelected.join(", ")} readOnly={true}/>
                <FormControl id="user-select-roles-id" componentClass="select" type="text"
                             name="rolesSelected" value={this.state.rolesSelected}
                             onChange={this.handleChange}
                             multiple={true} size={10} required={true}>
                    {roleOptions}
                </FormControl>
            </FormGroup>

          <div>
            <LinkContainer to="/settings/users">
              <Button>
                <FormattedMessage
                    id="studio.users.user-details.button.close"
                    defaultMessage="Back"
                />
              </Button>
            </LinkContainer>
            <Button type="submit" style={{marginLeft:10}}>
              <FormattedMessage
                  id="studio.users.user-details.button.update-user"
                  defaultMessage="Update user"
              />
            </Button>
          </div>
          <hr/>
        </form>
        <form onSubmit={this.updatePassword}>
          <h2>
            <FormattedMessage id="studio.users.user-details.title.passwordchange"
                                defaultMessage="Change user's password"/>
          </h2>
          <FormGroup controlId="user-pass-id">
            <ControlLabel>
              <FormattedMessage id="studio.users.user-details.label-password"
                                defaultMessage="Password:"
              />
            </ControlLabel>
            <FormControl type="password" name="password" value={this.state.password}
                         onChange={this.handleChange} required={true}/>
              {
                  this.state.password && this.state.password.length<4 &&
                  <HelpBlock>
                      <FormattedMessage
                          id="studio.users.user-details.help-password"
                          defaultMessage="Password length must be at least 4 characters"/>
                  </HelpBlock>
              }
          </FormGroup>
          <FormGroup controlId="user-pass-confirm-id">
            <ControlLabel>
              <FormattedMessage id="studio.users.user-details.label-password-confirm"
                                defaultMessage="Confirm password:"
              />
            </ControlLabel>
            <FormControl type="password" name="passwordConfirm" value={this.state.passwordConfirm}
                         onChange={this.handleChange} required={true}/>
              {
                  this.state.passwordConfirm && this.state.passwordConfirm!==this.state.password &&
                  <HelpBlock>
                      <FormattedMessage
                          id="studio.users.user-details.help-password-confirm"
                          defaultMessage="Password must be equal to confirm password"/>
                  </HelpBlock>
              }
          </FormGroup>
          <div>
            <Button type="submit" >
              <FormattedMessage
                  id="studio.users.user-details.button.update-password"
                  defaultMessage="Update password"
              />
            </Button>
          </div>
        </form>
        {this.state.modalDialog}
        </div>
    );
  }

}

export const UserDetailsPage = injectIntl(WithApi(UserDetailsPageComponent));
